module.exports = __webpack_public_path__ + "img/right-bg.b004991f.png";